// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import xProductPartNumbersStyles from "@guestsupply/App/SharedStyles/ProductPartNumbersStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { productInformationStyles } from "@guestsupply/Overrides/Widgets/ProductList/ProductListProductInformation";
import FreightCharges from "@guestsupply/XDL/Icons/FreightCharges";
import { createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import { ellipsis } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productInformationStyles.container = {
    gap: 0,
    css: css`
        width: 100%;
    `,
};
productInformationStyles.descriptionStyles = {
    productDetailLink: {
        ...createProductDescriptionStyles({
            productDetailLink: {
                css: css`
                    margin-bottom: 0;
                    align-items: baseline;
                    min-height: unset;
                `,
                typographyProps: {
                    size: 12,
                    css: css`
                        ${ellipsis(2)}
                    `,
                },
            },
        }).productDetailLink,
    },
};
productInformationStyles.brandGridItem = {
    width: 12,
};
productInformationStyles.descriptionGridItem = {
    width: 12,
    css: css`
        padding-bottom: 12px;
    `,
};
productInformationStyles.partNumbersGridItem = {
    width: 12,
};
productInformationStyles.swatchGridItem = {
    width: 12,
};
productInformationStyles.imageBadgeGridItem = {
    width: 12,
};
productInformationStyles.textBadgeGridItem = {
    width: 12,
    css: css`
        flex-wrap: wrap;
        align-items: flex-start;
        gap: 8px;
        height: ${({ isGridView }: any) => (isGridView ? "48px" : "auto")};
        ${xScreen("lte", "md")} {
            height: 48px;
        }
        ${xScreen("lte", "sm")} {
            height: auto;
        }
    `,
};
productInformationStyles.availabilityGridItem = {
    width: 12,
};
productInformationStyles.attributesGridItem = {
    width: 12,
};
productInformationStyles.searchScoreDataGridItem = {
    width: 12,
};
productInformationStyles.attributes = {
    attributeTypeText: {
        ...xProductPartNumbersStyles.label,
    },
    attributeValueText: {
        ...xProductPartNumbersStyles.value,
    },
};
productInformationStyles.partNumbersStyles = {
    container: {
        css: css`
            margin-bottom: 5px;
        `,
    },
};
productInformationStyles.smallHeadingStyle = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                height: 18px;
                margin-bottom: 8px;
            `,
        },
    }),
};
productInformationStyles.surchargesGridItem = {
    width: 12,
};
productInformationStyles.surchargesTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 0;
        `,
    },
};
productInformationStyles.totalFreightChargesLink = {
    ...createLinkIconStyles(FreightCharges, {
        typographyProps: {
            size: 12,
            weight: "bold",
            css: css`
                margin-left: 8px;
                line-height: 12px;
            `,
        },
        icon: {
            iconProps: {
                size: 18,
                color: "text.link",
            },
            position: "left",
        },
        css: css`
            &&& {
                display: flex;
            }
        `,
    }),
};
